export default __webpack_public_path__ + "static/2_20-2--a2e1ce925df77a0680c4037b89ac4ae8.png";